import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { useRouter } from 'app/helpers/routing';

import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';
import BroadenSearchButton from './BroadenSearchButton';

const BroadenSearchButtonContainer = ({ broadenedSearchType, isBroadened, query, searchType }) => {
  const router = useRouter();
  const library = useSelector(selectCurrentLibrary);
  const scopes = useSelector(selectCurrentSiteScopes);

  return (
    <BroadenSearchButton
      broadenedSearchType={broadenedSearchType}
      isBroadened={isBroadened}
      library={library}
      query={query}
      router={router}
      searchType={searchType}
      scopes={scopes}
    />
  );
};

BroadenSearchButtonContainer.propTypes = {
  broadenedSearchType: PropTypes.string,
  isBroadened: PropTypes.bool,
  query: PropTypes.string,
  searchType: PropTypes.string
};

export default BroadenSearchButtonContainer;
